export default __webpack_public_path__ + "static/media/BP3JPG-min.a160d1d3.jpg";